import { EventEmitter, Input, Output } from "@angular/core";
import { AbstractControl, FormGroup } from "@angular/forms";
import { ArrayHelper } from "../utilities/contracts/array-helper";
import { StringHelper } from "../utilities/contracts/string-helper";
import { DynamicControl } from "./dynamic-control.model";
import { DynamicFormEvent } from "./dynamic-form-event.model";

export abstract class DynamicControlComponent<T extends DynamicControl> {
  @Input() formGroup: FormGroup;
  @Input() model: T;

  @Output() onChange = new EventEmitter<DynamicFormEvent>();
  @Output() onInput = new EventEmitter<DynamicFormEvent>();
  @Output() onFocus = new EventEmitter<any>();
  @Output() onBlur = new EventEmitter<any>();

  get control(): AbstractControl {
    return this.formGroup.get(this.model.key);
  }

  get hidden(): boolean {
    return this.model.hidden;
  }

  get error(): string {
    const keys = Object.keys(this.control.errors || {});
    if (!ArrayHelper.isAvailable(keys)) {
      return "";
    }

    const firstError = keys[0];
    let message;
    if (this.model && this.model.errorMessages) {
      message = this.model.errorMessages[firstError];
    }

    if (!StringHelper.isAvailable(message)) {
      message = this.control.errors[firstError];
    }

    if (typeof message !== "string") {
      // TODO: Force error messages to be present?
      message = "";
    }

    return message;
  }

  get hasError(): boolean {
    return this.control
      && this.control.invalid
      && StringHelper.isAvailable(this.error)
      && (this.control.dirty || this.control.touched);
  }


  protected getClasses(inputType: string): string {
    let classes = `control__input control__input--${inputType}`;

    if (this.model.isAdmin) {
      classes = `${classes} control__input--admin`;
    } else if (this.model.isChanged) {
      classes = `${classes} control__input--${this.model.workflowStatusName}`;
    }

    return classes;
  }
}
